type Props = {
    width?:number;
    height?:number;
    fill?:string;
}

const HumanIcon = ({
    width =12,
    height=12,
    fill
}: Props) =>{
    return (
       <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M6 2.25C5.173 2.25 4.5 2.92275 4.5 3.75C4.5 4.57725 5.173 5.25 6 5.25C6.82725 5.25 7.5 4.57725 7.5 3.75C7.5 2.92275 6.82725 2.25 6 2.25ZM6 6.25C4.6215 6.25 3.5 5.1285 3.5 3.75C3.5 2.3715 4.6215 1.25 6 1.25C7.3785 1.25 8.5 2.3715 8.5 3.75C8.5 5.1285 7.3785 6.25 6 6.25ZM9.75 10.75H9.5V9.688C9.5 8.61775 8.63225 7.75 7.562 7.75H4.438C3.36775 7.75 2.5 8.61775 2.5 9.688V10.75H2.25C1.83575 10.75 1.5 10.4143 1.5 10V9.688C1.5 8.0655 2.8155 6.75 4.438 6.75H7.562C9.1845 6.75 10.5 8.0655 10.5 9.688V10C10.5 10.4143 10.1643 10.75 9.75 10.75Z" fill="#5D6E69"/>
</svg>

    )
}

export default HumanIcon;